import { Utils } from "../../../shared/constants/utilities.constants";

export class BuildingSiteFormViewModel {
    public name: string
    public code?: string
    public street: string;
    public country: string;
    public countryId: string;
    public postalCode: string;
    public city: string;
    public mobile?: string;
    public phone: string;
    public email?: string;
    public firstName?: string;
    public lastName?: string;
    public countryName?: string;
    public contactId?: string;
    public addressId?: string;
    constructor() {
        this.name = '';
        this.street = '';
        this.country = '';
        this.countryId = Utils.defaultUuid;
        this.postalCode = '';
        this.city = '';
        this.phone = '';
    }
}